module.exports = __webpack_public_path__ + "static/original-mattress-firmness-291c8823ce2543476a6ecba8becbf3c5.mp4";